import {useRoute} from 'vue-router'
import {useStore} from 'vuex'

type Props = {
  vuexStoreName: string
}

export const calcNotAvailableType = ({ vuexStoreName }: Props): string | null => {
  const route = useRoute()
  const store = useStore()
  const hasAvailableFranchiseesStoreOption = store.getters['companiesCompany/hasAvailableFranchiseesStoreOption']
  const hasAvailableUserCompanyStoreOption = store.getters['companiesCompany/hasAvailableUserCompanyStoreOption']
  const hasAvailableAreaStoreOption = store.getters['companiesCompany/hasAvailableAreaStoreOption']
  const hasVisibleStores = store.getters['companiesStores/hasVisibleStores']
  const analyzableSurveys = store.getters['companiesCustomSurveySurveys/analyzableSurveys']
  const isEmptyStores = store.getters['companiesStores/isEmpty']
  const hasReadableCompetitors = store.getters['companiesCompany/hasReadableCompetitors']
  const crossSearchField = store.getters[`${vuexStoreName}/crossSearchField`]
  const pageType = store.state[`${vuexStoreName}/pageType`]

  if (route.path.includes('/analysis/')) {
    if (isEmptyStores) return 'emptyStore'
    const inFranchiseeAnalysis = crossSearchField?.fields === 'franchisee_id' || pageType?.fields === 'franchisee_id'
    const inUserCompanyAnalysis = crossSearchField?.fields === 'user_company_id' || pageType?.fields === 'user_company_id'
    const inAreaAnalysis = crossSearchField?.fields === 'area_id' || pageType?.fields === 'area_id'
    if (inFranchiseeAnalysis && !hasAvailableFranchiseesStoreOption) {
      return 'emptyFranchisee'
    } else if (inUserCompanyAnalysis && !hasAvailableUserCompanyStoreOption) {
      return 'emptyUserCompany'
    } else if (inAreaAnalysis && !hasAvailableAreaStoreOption) {
      return 'emptyArea'
    } else if (route.path.includes('/analysis/visitors') && !hasVisibleStores) {
      return 'disableStorePage'
    } else if (route.path.includes('/analysis/surveys') && analyzableSurveys.length === 0) {
      return 'disableSurvey'
    } else if ((route.path.includes('/analysis/keywords')
      || route.path.includes('/analysis/reviews')
      || route.path.includes('/analysis/qscas/detail')) && !hasReadableCompetitors) {
      return 'emptyCompetitor'
    }
  }

  return null
}
